// extracted by mini-css-extract-plugin
export default {"block":"abATmA","external":"bbATmA"};